module.exports = __webpack_public_path__ + "static/media/img_cal8.45a5aa0d.jpg";